import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD, HREF_FIELD } from "../commonFields";

export const interactiveBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Interactive Block",
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  canHaveChildren: true,
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Text",
        options: {
          text: {
            "@type": "@builder.io/core:LocalizedValue",
            Default: "Lorem ipsum",
          },
        },
      },
      meta: {
        localizedTextInputs: ["text"],
        "transformed.text": "localized",
      },
    },
  ],
  inputs: [
    {
      name: "link",
      type: "object",
      helperText: "If URL is filled, block will be used as a link",
      subFields: [
        HREF_FIELD,
        {
          ...DLD_FIELD,
          required: false,
        },
        {
          ...DLT_FIELD,
          required: false,
        },
      ],
    },
    {
      name: "interactionStyles",
      type: "list",
      subFields: [
        {
          name: "childClass",
          type: "string",
          helperText: "Leave empty to apply styles to all children",
        },
        {
          name: "hoverStyle",
          type: "uiStyle",
          localized: false,
          defaultValue: {},
        },
        {
          name: "activeStyle",
          type: "uiStyle",
          localized: false,
          defaultValue: {},
        },
        {
          name: "focusStyle",
          type: "uiStyle",
          localized: false,
          defaultValue: {},
        },
        {
          name: "focusVisibleStyle",
          type: "uiStyle",
          localized: false,
          defaultValue: {},
        },
        {
          name: "visitedStyle",
          type: "uiStyle",
          localized: false,
          defaultValue: {},
        },
      ],
    },
  ],
};
